import React from 'react';
import { Factory } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ProductSection = ({ title, icon: Icon, children }) => (
  <div>
    <h4 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
      <Icon className="w-6 h-6 mr-2 text-amber-600" />
      {title}
    </h4>
    {children}
  </div>
);

const BulkPackagingGrid = ({ packages }) => (
  <ProductSection title="Bulk Packaging" icon={Factory}>
    <div className="grid md:grid-cols-2 gap-6">
      {packages.map((pack) => (
        <Card key={pack.type} className="overflow-hidden border-2 hover:shadow-xl transition-all">
          <div className="relative h-64">
            <img src={pack.image} alt={pack.type} className="w-full h-full object-cover" />
            <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg">
              <h5 className="text-xl font-bold text-gray-900">{pack.type}</h5>
            </div>
          </div>
          <CardContent className="p-5">
            <p className="text-gray-700 mb-2">{pack.description}</p>
            <p className="text-sm font-semibold text-amber-600">Capacity: {pack.capacity}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  </ProductSection>
);

const InfoCard = ({ icon: Icon, iconColor = 'green', bgFrom = 'green-50', bgTo = 'emerald-50', borderColor = 'green-200', title, children }) => (
  <Card className={`bg-gradient-to-br from-${bgFrom} to-${bgTo} border-2 border-${borderColor}`}>
    <CardContent className="p-8">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className={`w-14 h-14 bg-${iconColor}-100 rounded-full flex items-center justify-center`}>
            <Icon className={`w-7 h-7 text-${iconColor}-600`} />
          </div>
        </div>
        <div>
          <h4 className="text-xl font-bold text-gray-900 mb-2">{title}</h4>
          {children}
        </div>
      </div>
    </CardContent>
  </Card>
);

export { ProductSection, BulkPackagingGrid, InfoCard };
